module.exports = __webpack_public_path__ + "static/media/money_icon.70c82daa.svg";